import seoReducerMap from 'wanderu-ducks-seo';

import CarrierContact from '../containers/CarrierContact/CarrierContact';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default CarrierContact;
